import { useForm } from "react-hook-form";
import Button from "../../../student/components/generic/button";
import { useCheckEmail } from "../../utils/useCheckEmail";
import { LicenseInviteState } from "./types";
import { InviteGoogleAuth } from "./InviteGoogleAuth";

// Note: this is a separate component to avoid re-rendering the entire
// InviteEnterEmail component (including GoogleLoginButton) on every keystroke
const EmailForm: React.FC<{
  setInviteState: (state: LicenseInviteState) => void;
}> = ({ setInviteState }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setError,
  } = useForm<{ email: string }>();

  const { checkEmail, isLoading: isCheckingEmail } = useCheckEmail(
    watch("email")
  );

  const onSubmit = async (data: any) => {
    const result = await checkEmail();
    if (result.success) {
      setInviteState({ state: "createAccount", email: data.email });
    } else if (result.reason === "exists") {
      setInviteState({ state: "login", email: data.email });
    } else if (result.reason === "invalid") {
      setError("email", {
        type: "manual",
        message:
          typeof result.message === "string"
            ? result.message
            : "Please enter a valid email address",
      });
    } else if (result.reason === "error") {
      setError("email", {
        type: "manual",
        message:
          "There was an error while checking your email. Please try again.",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <label className="text-sm font-bold" htmlFor="email">
          Email
        </label>
        <input
          className="h-10 rounded px-3 py-0"
          type="email"
          id="email"
          {...register("email", { required: "This field is required" })}
        />
        {errors.email && (
          <span className="text-sm text-dm-error-500">
            {errors.email.message}
          </span>
        )}
      </div>
      <Button isLoading={isCheckingEmail}>Continue</Button>
    </form>
  );
};

export const InviteEnterEmail: React.FC<{
  isFirstSlide: boolean;
  accountType: "parent" | "learner";
  setInviteState: (state: LicenseInviteState) => void;
}> = ({ isFirstSlide, accountType, setInviteState }) => {
  return (
    <>
      <div className="flex flex-col gap-2">
        <h1 className="text-center font-serif text-2xl font-bold text-dm-brand-blue-600">
          {isFirstSlide ? "Welcome!" : "Let's Get Started!"}
        </h1>
        <h2 className="text-center font-serif text-lg font-bold">
          Enter your email to continue.
        </h2>
      </div>

      <EmailForm setInviteState={setInviteState} />

      <span className="w-full text-center font-bold">Or</span>

      <InviteGoogleAuth
        accountType={accountType}
        setInviteState={setInviteState}
      />
    </>
  );
};
